/* eslint-disable no-unused-vars */
import "./PodCastTools.css";
import React, { useLayoutEffect, useState, useEffect, useCallback, useMemo, useRef, useContext } from "react";
import { VoiceBotStateContext } from "./VoiceBotStateContext";
import PlaylistSelector from "./PlaylistSelector";
import { getAuth } from "firebase/auth";
import { db } from "../utils/firebase";
import {  doc, 
          setDoc,
          getDoc, 
          getDocs, 
          collection
        } from "firebase/firestore";
import { useAuth } from "./AuthContext";
import axios from "axios";
import YouTube from "react-youtube";
import InputForm from './InputForm';
import Text from "./Text";
function PodCastTools() {
  const [videoId, setVideoId] = useState('SjNQQ26gZGI'); // Default video ID
  const isValidYouTubeId = (id) => typeof id === "string" && /^[A-Za-z0-9_-]{11}$/.test(id);
  const [playlistVideos, setPlaylistVideos] = useState([]);
  const [isPlaylistVisible, setIsPlaylistVisible] = useState(true);
  const [boxVisible, setBoxVisible] = useState(false);
  const [transcript, setTranscript] = useState(''); // State for the transcript
  const [content, setContent] = useState('');
  const [player, setPlayer] = useState(null); // Store the YouTube player instance
  const API_KEY = process.env.REACT_APP_GOOGLE_CLOUD_API_KEY2;
  const API_BASE = process.env.REACT_APP_FLUENCY_SERVER?.replace(/\/+$/, "");
  const [PLAYLIST_ID, setPLAYLIST_ID] = useState('PLblaVxcRe39xzkN6H28tnHOJt_fhfZzqo');
  const [showModal, setShowModal] = useState(false);
  const [isFadingOut, setIsFadingOut] = useState(false);
  const [vocabulary, setVocabulary] = useState([]);
  const [userLevel, setUserLevel] = useState('A1');
  const [focus, setFocus] = useState('Begin');
  const { userRole } = useAuth();
  const [vocabularyList, setVocabularyList] = useState(null);
  const [vocabularyMap, setVocabularyMap] = useState(null);
  const [login, setLogin] = useState(false);
  const [showing, setShowing] = useState(false);
  const [room, setRoom] = useState('');  // Default room
  const [lastInteraction, setLastInteraction] = useState('');
  const playerRef = useRef(null);
  const [numTrials, setNumTrials] = useState(3); // Default trials set to 3
  const [title, setTitle] = useState('');
  const BEARER_TOKEN = process.env.REACT_APP_X_BEARER_TOKEN; //X Bearer Token
  const items = ['En', 'Fl', 'Pr','Be', 'Vo', 'Gr', 'Ta', 'Id', 'Pe', 'Cu', 'Lo', 'Te'];
  const [videoDuration, setVideoDuration] = useState(0);
  const [user, setUser] = useState(null);
  const [videoIds, setVideoIds] = useState([]);
  const [selectedVideoId, setSelectedVideoId] = useState(null);
  const [progress, setProgress] = useState(0);
  const [segmentCap, setSegmentCap] = useState(10);
  const [videos, setVideos] = useState([]); // { id: videoId, title: videoTitle }
  const [searchQuery, setSearchQuery] = useState('');
  const wrapRef = useRef(null);
  const [repeatCycleActive, setRepeatCycleActive] = useState(false);
  
  const handleTrialSelect = (trials) => {
    setNumTrials(trials);
  };
  
    useEffect(() => {
      let isMounted = true;

      const fetchVocabularyData = async (videoId) => {
        try {
          const { data } = await axios.get(
            `https://transcript.ispeakwell.ca/transcript?video_id=${videoId}`
          );
          const { nlp_data, transcript: events } = data;

          const vocabMap = {};
          (nlp_data?.unique_tokens || []).forEach((token) => {
            const lower = token.toLowerCase();
            const times = events
              .filter((e) =>
                e.text.toLowerCase().split(/\W+/).includes(lower)
              )
              .map((e) => e.start);
            vocabMap[token] = times;
          });

          if (isMounted) {
            setVocabulary(vocabMap);
          }
        } catch (err) {
          console.error("Error fetching vocabulary:", err);
        }
      };

      if (videoId) fetchVocabularyData(videoId);

      return () => {
        isMounted = false;
      };
    }, [videoId]);

  // =======================================================
  // SUPER-STABLE TRANSCRIPT LOADER FOR VB.js
  // =======================================================

  const [transcriptState, setTranscriptState] = useState({
    loading: false,
    error: null,
    data: null,
    videoId: null,
    stale: false
  });

  useEffect(() => {
    if (!videoId || !transcriptState?.data?.transcript) return;

    const transcript = transcriptState.data.transcript;

    const vocabMap = {};
    const order = [];
    const seen = new Set();

    for (const seg of transcript) {
      const words = seg.text
        .toLowerCase()
        .split(/\W+/)
        .filter(Boolean);

      for (const w of words) {
        if (!vocabMap[w]) vocabMap[w] = [];
        vocabMap[w].push(seg.start);

        if (!seen.has(w)) {
          seen.add(w);
          order.push(w);
        }
      }
    }

    // EXACT VBOLD.js structure:
    setVocabularyList(order);     // <- list of words ONLY
    setVocabularyMap(vocabMap);   // <- word → [timestamps]
    
  }, [videoId, transcriptState.data]);

  const loadTranscript = useCallback(
    async (videoId, { allowRetry = true } = {}) => {
      // IMMEDIATE RESET
      setTranscriptState({
        loading: true,
        error: null,
        data: null,
        videoId,
        stale: false
      });

      if (!videoId || videoId.length !== 11) {
        setTranscriptState({
          loading: false,
          error: "Invalid video ID",
          data: null,
          videoId,
          stale: false
        });
        return;
      }

      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 15000);

      try {
        const res = await fetch(
          `https://transcript.ispeakwell.ca/transcript?video_id=${videoId}`,
          { signal: controller.signal }
        );

        clearTimeout(timer);

        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.message || "Transcript error");
        }

        const json = await res.json();

        // SUCCESS
        setTranscriptState({
          loading: false,
          error: null,
          data: json,
          videoId,
          stale: false
        });

      } catch (err) {
        console.warn("Transcript load failed:", err);

        if (allowRetry) {
          // SAFE RETRY using the *same* memoized function
          setTimeout(() => loadTranscript(videoId, { allowRetry: false }), 800);
          return;
        }

        // Final failure
        setTranscriptState({
          loading: false,
          error: err.message || "Could not load transcript",
          data: null,
          videoId,
          stale: true
        });
      }
    },
    [] // no dependencies — correct, safe, stable
  );


  useEffect(() => {
    if (videoId) {
      loadTranscript(videoId);
    }
  }, [videoId, loadTranscript]);


  useEffect(() => {
    const el = wrapRef.current;
    if (!el) return;

    const BASE_W = 1920;   // match VB-stage CSS width
    const BASE_H = 1080;   // match VB-stage CSS height

    const update = () => {
      const W = el.clientWidth;
      const H = el.clientHeight;
      const scale = Math.min(W / BASE_W, H / BASE_H);
      el.style.setProperty("--vb-scale", String(scale));
    };

    const ro = new ResizeObserver(update);
    ro.observe(el);
    window.addEventListener("resize", update);
    update();

    return () => {
      ro.disconnect();
      window.removeEventListener("resize", update);
    };
  }, []);
   
  // Share‐handler lives here
  const handleShareTask = () =>{
    return;
  };

  const [sharedFormData, setSharedFormData] = useState(null);

  useEffect(() => {
    if (selectedVideoId) {
      setVideoId(selectedVideoId);
    }
  }, [videoId, selectedVideoId]);

  const closeModal = () => {
    setIsFadingOut(true);
    setTimeout(() => {
      setShowModal(false);
      setIsFadingOut(false);
    }, 400); // match fadeOut animation duration
  };

  
  useEffect(() => {
    // Fetch videoIds from Firestore on component mount
    const fetchVideoIds = async () => {
      console.log("Firebase: Fetching video IDs");
      try {
        const auth = getAuth();
        const user = auth.currentUser;
        const querySnapshot = await getDocs(collection(db, "users", user.uid, "videoIDs",)); // 'videos' is the collection name
        const ids = querySnapshot.docs.map(doc => doc.data().videoId); // Assuming each document has a videoId
        setVideoIds(ids);  // Save the videoIds to state
      } catch (error) {
        console.error("Error fetching video IDs: ", error);
      }
    };

    fetchVideoIds();
  }, []);  // Empty dependency array ensures this runs only once when the component mounts
    
  useEffect(() => {
    const fetchVideoTitles = async () => {
      try {
        if (!API_KEY) {
          console.error("API key is missing.");
          return;
        }
    
        const validIds = videoIds.filter(id => {
          const isValid = typeof id === 'string' && /^[a-zA-Z0-9_-]{11}$/.test(id);
          if (!isValid) console.warn("Invalid videoId skipped:", id);
          return isValid;
        });
    
        if (validIds.length === 0) {
          console.warn("No valid video IDs to fetch.");
          return;
        }
    
        console.log("Fetching video titles in batches...");
    
        const BATCH_SIZE = 50;
        const chunks = [];
    
        for (let i = 0; i < validIds.length; i += BATCH_SIZE) {
          chunks.push(validIds.slice(i, i + BATCH_SIZE));
        }
    
        const allVideos = [];
    
        for (const chunk of chunks) {
          const ids = chunk.join(',');
          const response = await fetch(
            `https://www.googleapis.com/youtube/v3/videos?part=snippet&id=${ids}&key=${API_KEY}`
          );
          const data = await response.json();
    
          if (!data.items) {
            console.error("YouTube API Error:", data.error);
            continue; // Skip this chunk
          }
    
          const videosWithTitles = data.items.map(item => ({
            id: item.id,
            title: item.snippet.title
          }));
    
          allVideos.push(...videosWithTitles);
        }
    
        setVideos(allVideos);
      } catch (error) {
        console.error("Failed to fetch video titles:", error);
      }
    };
    
  
    fetchVideoTitles();
  }, [videoIds, API_KEY]);
  

  const handleSelectChange = (event) => {
    const nextId = event.target.value;
    setSharedFormData([]);
    setSelectedVideoId(nextId || null);
    if (!nextId) return;
    setVideoDuration(0);
    setVideoId(nextId);
  };

  const titleRef = useRef(title);
  const [formData, setFormData] = useState(() => {
    // Attempt to get stored data from localStorage
    const storedData = localStorage.getItem('formData');
    
    // If data exists, parse and use it; otherwise, initialize with an empty array
    console.log('Loaded formData from localStorage:', storedData); // Add logging to verify
    return storedData ? JSON.parse(storedData) : [];
  });
 
  // This function is passed to InputForm to receive the updated data
  const handleFormUpdate = useCallback((updatedRows) => {
    // Save the updated rows to the parent component's state
    setFormData(updatedRows);
  
    // Save the updated rows to localStorage so that it persists even when the component is hidden
    localStorage.setItem('formData', JSON.stringify(updatedRows));
  }, []);
  
  const addInteraction = (newInteraction) => {
    setLastInteraction(newInteraction);
  };
   
  useEffect(() => {
    const auth = getAuth(); // Get the Auth instance
    const currentUser = auth.currentUser; // Access the current authenticated user
    const role = userRole;
    setUser(currentUser); // Update state with the current user
    console.log(currentUser, role);
  }, [userRole]);

  // Convert seconds into hh:mm:ss format
  const formatTimes = (seconds) => {
    const hours = Math.floor(seconds / 3600); // Get hours
    const minutes = Math.floor((seconds % 3600) / 60); // Get minutes
    const secs = Math.floor(seconds % 60); // Get remaining seconds
    
    // Add leading zeros for single-digit hours, minutes, and seconds
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };


    
  const handleInputChange = async (e) => {
    const newVideoUrl = e.target.value;
    const newVideoId = getVideoIdFromUrl(newVideoUrl);  
    setVideoId(newVideoId); // Update the videoId state
    setSelectedVideoId(newVideoId);
    if (!newVideoId) {
      console.error("Invalid YouTube URL");
      return;
    }

    // Reset the duration to 0 before fetching the new video
    setVideoDuration(0);

    try {
      const videoPlayer = playerRef.current;
      if (videoPlayer) {
        videoPlayer.onloadedmetadata = () => {
          const duration = videoPlayer.duration;
          setVideoDuration(duration);  // Store the new duration
        };
      }
    } catch (error) {
      console.error("Error handling video input change:", error);
    }
  };
   
 // Use useEffect to handle videoDuration updates
  useEffect(() => {
    if(!videoId) return;
    console.log("Writing to videoIDs Firebase.");
    const saveVideoIdIfNeeded = async (videoId) => {
      // Create a reference to the video document (if it doesn't exist, Firestore will create it)
      const videoRef = doc(db, "users", user.uid, "videoIDs", videoId); // Create a doc reference
    
      try {
        const docSnap = await getDoc(videoRef); // Retrieve the document using the reference
    
        if (docSnap.exists()) {
          console.log("Video ID already exists in the database");
          return false;  // If the document exists, we don't save it again
        } else {
          // If the document doesn't exist, create a new one
          await setDoc(videoRef, {
            videoId: videoId,
            createdAt: new Date(),  // Optionally add metadata like the creation date
          });
          console.log("Video ID saved successfully");
          return true;  // Return true indicating the video ID was saved
        }
      } catch (error) {
        console.error("Error checking video ID in database:", error);
      }
    };

    if (videoDuration > 0) {
      saveVideoIdIfNeeded(videoId);
    }
  }, [videoDuration, videoId, user]);
  
  // Fetch playlist videos on component mount
  useEffect(() => {
    let isMounted = true;
  
    const fetchPlaylistVideos = async () => {
      let nextPageToken = '';
      let allVideos = [];
  
      do {
        const response = await fetch(`https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=${PLAYLIST_ID}&maxResults=50&key=${API_KEY}${nextPageToken ? `&pageToken=${nextPageToken}` : ''}`);
        const data = await response.json();
        if (!response.ok) {
          console.error('YouTube API error', data);
          throw new Error(data.error?.message ?? `HTTP ${response.status}`);
        }
        allVideos = allVideos.concat(data.items);
        nextPageToken = data.nextPageToken;
      } while (nextPageToken);
  
      if (isMounted) {
        setPlaylistVideos(allVideos);
      }
    };
  
    fetchPlaylistVideos();
    return () => {
      isMounted = false;
    };
  }, [API_KEY, PLAYLIST_ID]);
  

  useEffect(() => {
    document.body.classList.add('no-scroll');
    document.documentElement.classList.add('no-scroll');
    return () => {
      document.body.classList.remove('no-scroll');
      document.documentElement.classList.remove('no-scroll');
    };
  }, []);
  

  const handlePlayerReady = (event) => {
    setPlayer(event.target);
    playerRef.current = event.target;
    const duration = event.target.getDuration();
    setVideoDuration(duration); // Store the duration in state
  };

  const handlePlayerStateChange = (event) => {
    if (event.data === window.YT.PlayerState.PLAYING) {
    }
    if (event.data === window.YT.PlayerState.ENDED) {
      // find where we are in the playlist
      const currIdx = playlistVideos.findIndex(
        v => v.snippet.resourceId.videoId === selectedVideoId
      );

      // if there's a next one, fire your existing `handleInputChange` on it:
      if (currIdx >= 0 && currIdx < playlistVideos.length - 1) {
        const nextId = playlistVideos[currIdx + 1].snippet.resourceId.videoId;
        setVideoId(nextId);
        setSelectedVideoId(nextId);
        setVideoDuration(0);

        // 5a. Load AND start playing the next clip immediately:
        playerRef.current.loadVideoById({
          videoId: nextId,
          startSeconds: 0,
        });
      }
    }
  };

  const getVideoIdFromUrl = (urlOrId) => {
    if (!urlOrId) return null;

    // If the input is already a video ID (11 characters long), return it as-is
    if (urlOrId.length === 11 && /^[A-Za-z0-9_-]+$/.test(urlOrId)) {
      return urlOrId; // Return the video ID as-is
    }

    // Otherwise, treat the input as a URL and try to extract the video ID
    const match = urlOrId.match(/(?:https?:\/\/(?:www\.)?youtube\.com\/(?:[^/]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=))([^"&?/\s]{11})/);
    return match ? match[1] : null; // Return the video ID if a match is found, or null
  };

  const handlePlaylistShow = () => {
    setShowModal(true);
  }; 

// ============================================================
//  SAFE CALLBACK WRAPPER
// ============================================================
  const safeCall = (fn) => {
    if (typeof fn === "function") fn();
  };

// ============================================================
//  PLAY HANDLER
// ============================================================
  const handlePlay = (args = {}) => {
    const { onStart, onEnd } = args;

    try {
      safeCall(onStart);
      if (repeatCycleActive) return;

      if (playerRef.current) {
        playerRef.current.playVideo();
      }

      addInteraction("Video playing.");
    } finally {
      safeCall(onEnd);
    }
  };

  // ============================================================
  //  PAUSE HANDLER
  // ============================================================
  const handlePause = (args = {}) => {
    const { onStart, onEnd } = args;

    try {
      safeCall(onStart);
      if (repeatCycleActive) return;

      if (playerRef.current) {
        playerRef.current.pauseVideo();
      }

      addInteraction("Video paused.");
    } finally {
      safeCall(onEnd);
    }
  };

  // ============================================================
  //  REPEAT 500ms
  // ============================================================
  const handleRepeat500ms = (args = {}) => {
    const { onStart, onEnd } = args;

    try {
      safeCall(onStart);
      if (repeatCycleActive) return;

      if (playerRef.current) {
        const currentTime = playerRef.current.getCurrentTime();
        playerRef.current.seekTo(Math.max(currentTime - 0.75, 0));
      }

      addInteraction("Video quick repeat practice.");
    } finally {
      safeCall(onEnd);
    }
  };

  // ============================================================
  //  REPEAT 2s
  // ============================================================
  const handleRepeat2s = (args = {}) => {
    const { onStart, onEnd } = args;

    try {
      safeCall(onStart);
      if (repeatCycleActive) return;

      if (playerRef.current) {
        const currentTime = playerRef.current.getCurrentTime();
        playerRef.current.seekTo(Math.max(currentTime - 2.25, 0));
      }

      addInteraction("Video long repeat practice.");
    } finally {
      safeCall(onEnd);
    }
  };

  // ============================================================
  //  REPEAT CYCLE (AUTO PRACTICE)
  // ============================================================
  let repeatInterval = null;

  const wait = (ms) => new Promise((res) => setTimeout(res, ms));

  const handleRepeatCycle = async (args = {}) => {
    const { onStart, onEnd } = args;

    try {
      safeCall(onStart);

      if (repeatCycleActive) return;

      setRepeatCycleActive(true);
      addInteraction("Video repeat cycle training initiated.");

      const player = playerRef.current;
      if (!player) {
        setRepeatCycleActive(false);
        return;
      }

      const totalTrials = numTrials;

      // Starting point
      let startTime = player.getCurrentTime() - 3;
      if (startTime < 0) startTime = 0;

      // Cancel previous cycle
      if (repeatInterval) {
        clearInterval(repeatInterval);
        repeatInterval = null;
      }

      try {
        player.pauseVideo();
        player.seekTo(startTime);

        // Perform trials
        for (let i = 0; i < totalTrials; i++) {
          // PLAY segment
          player.seekTo(startTime);
          player.unMute();
          player.playVideo();
          await wait(3000);

          // SILENCE segment
          player.pauseVideo();
          await wait(3000);
        }

        // Resume normal playback
        player.unMute();
        player.playVideo();
      } finally {
        setRepeatCycleActive(false);
      }
    } finally {
      safeCall(onEnd);
    }
  };

  // ============================================================
  //  STOP HANDLER
  // ============================================================
  const handleStop = (args = {}) => {
    const { onStart, onEnd } = args;

    try {
      safeCall(onStart);

      if (repeatInterval) {
        clearInterval(repeatInterval);
        repeatInterval = null;
      }

      if (playerRef.current) {
        playerRef.current.pauseVideo();
        playerRef.current.seekTo(0);
      }
    } finally {
      safeCall(onEnd);
    }
  };

  const fetchTranscript = async () => {
    if (!isValidYouTubeId(videoId)) {
      setTranscript(["Enter a valid 11-character YouTube ID."]);
      setVocabulary({ tokens: [], map: {} });
      return;
    }
    try {
      const response = await axios.get(
        `https://transcript.ispeakwell.ca/transcript?video_id=${videoId}`
      );

      if (!response.data) {
        setTranscript(["Error: Invalid response format."]);
        setVocabulary({ tokens: [], map: {} });
        return;
      }

      const { transcript: events, vocab_map, nlp_data } = response.data;

      if (Array.isArray(events) && events.length) {
        setTranscript(
          events.map((e, i) => {
            const displayTimestamp = formatTimestamp(e.start);
            const cleanedText = e.text.replace(/\n+/g, ' ');

            return (
              <div
                key={i}
                className="transcript-line"
                style={{ margin: '8px 0', cursor: 'pointer' }}
                onClick={() => handleTimestampClick(e.start)}
              >
                <span style={{ fontWeight: 'bold' }}>
                  [{displayTimestamp}]
                </span>{" "}
                {cleanedText}
              </div>
            );
          })
        );

        // ✅ store tokens in order they came from NLP, plus the map for lookups
        setVocabulary({
          tokens: nlp_data.unique_tokens || [],
          map: vocab_map || {}
        });
      } else {
        setTranscript(["No transcript available for this video."]);
        setVocabulary({ tokens: [], map: {} });
      }
    } catch (error) {
      console.error("Error fetching transcript:", error);
      setTranscript(["Error fetching transcript."]);
      setVocabulary({ tokens: [], map: {} });
    }
  };

  const handleVideoClick = async (id) => {
    setVideoId(id);
    setSelectedVideoId(id);
    await fetchTranscript(id); // Fetch the transcript for the clicked video
  };

  const togglePlaylistVisibility = () => {
    setIsPlaylistVisible(prev => !prev);
  };

  function formatTimestamp(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = Math.floor(seconds % 60);

    return `${hours > 0 ? `${hours}:` : ''}${minutes < 10 && hours > 0 ? `0${minutes}` : minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  }

  const handleTimestampClick = (seconds) => {
    if (!playerRef.current) {
      console.error("Player is not ready");
      return;
    }
    playerRef.current.seekTo(seconds, true);
  };

  const opts = {
    height: '290',
    width: '520',
    playerVars: {
      controls: 1,
      enablejsapi: 1,
      origin: window.location.origin,
    },
  };

  const filteredVideos = videos.filter(video => {
    const query = searchQuery.trim().toLowerCase();
    const queryWords = query.split(/\s+/); // split on one or more spaces
  
    const title = video.title.toLowerCase();
    const id = video.id.toLowerCase();
  
    // Match if all query words are present in the title (basic fuzzy match)
    const matchesAllWords = queryWords.every(word => title.includes(word));
  
    // Also allow direct video ID match
    return matchesAllWords || id === query;
  });

  return (
    <div className="PCT-container">
      <div className="PCT-stage-wrapper" ref={wrapRef}>
        <div className="PCT-stage">
          <h1 className="PCT-header-title">iSpeakWell Podcast Tools</h1>
            <div className = "role-container">
              <div className="PCT-main-container">
                <div className="PCT-video-input-container">
                  <label>Player</label>
                  <div className="PCT-video-container">
                    <YouTube
                      videoId={videoId}
                      opts={opts}
                      onReady={handlePlayerReady}
                      onStateChange={handlePlayerStateChange}
                    />
                    <div className="PCT-input-container">
                      <input
                        type="text"
                        value={videoId || ''}
                        onChange={handleInputChange}
                        placeholder="Import YouTube video ID"
                      />
                      <button className="VidPlayButton" onClick={() => loadTranscript(videoId)}>Get</button>
                      <button className="VidPlayButton" onClick={handlePlaylistShow}>Playlist</button>
                    </div>
                    <div className="PCT-playlist-container">
                      <h3 className="PCT-playlist-title" onClick={togglePlaylistVisibility} style={{ cursor: 'pointer', color: 'grey' }}>
                        Sources
                      </h3>
                      <div className={`PCT-playlist-list ${isPlaylistVisible ? 'fade-in' : 'fade-out'}`}>
                        {isPlaylistVisible && (
                          <ul>
                            {playlistVideos.length > 0 ? (
                              playlistVideos
                                .filter(Boolean)
                                .map(video => (
                                  video.snippet ? (
                                    <li 
                                      key={video.id} 
                                      onClick={() => handleVideoClick(video.snippet.resourceId.videoId)}
                                      style={{ cursor: 'pointer', color: 'grey' }}
                                    >
                                      {video.snippet.title}
                                    </li>
                                  ) : null
                                ))
                            ) : (
                              <p>No videos found in the playlist.</p>
                            )}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="PCT-Transcript-Container">
                  <label>Transcript</label>
                  <div style={{ color: 'white', overflowY: 'auto'}}>
                    {transcriptState.loading && (
                      <div className="t-status loading">Loading transcript…</div>
                    )}

                    {transcriptState.error && (
                      <div className="t-status error">{transcriptState.error}</div>
                    )}

                    {!transcriptState.loading &&
                    !transcriptState.error &&
                    !transcriptState.data && (
                      <div className="t-status empty">
                        No transcript loaded.
                      </div>
                    )}

                    {transcriptState.stale && (
                      <div className="t-status stale">
                        Transcript could not be refreshed. Showing old result.
                      </div>
                    )}

                    <div className="t-content">
                      {(transcriptState.data?.transcript || []).map((evt, index) => (
                        <div
                          key={index}
                          className="t-line"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            if (playerRef.current && evt.start) {
                              playerRef.current.seekTo(evt.start, true);
                              playerRef.current.playVideo();
                            }
                          }}
                        >
                          <span className="t-time">[{formatTimes(evt.start.toFixed(2))}]</span> {evt.text}
                        </div>
                      ))}
                    </div>
                    <Text />
                  </div>
                </div>
                <div>
                  <div className="PCT-input-form">
                    <label>Clip Manager</label>
                    <div className="PCT-search-input-container">
                      <input
                        type="text"
                        placeholder="Search by title or video ID..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="PCT-search-input"
                      />
                      <button 
                        className="PCT-clear-search-button" 
                        onClick={() => {
                          setSearchQuery('');
                          setSelectedVideoId(null);
                          setSharedFormData([]);
                        }}
                      >
                        Clear
                      </button>
                    </div>
                    <select className="PCT-SelectVids" onChange={handleSelectChange} value={selectedVideoId ?? ""}>
                      <option value="">Select a video import to fluentize...</option>
                      {filteredVideos.map((video, index) => (
                        <option key={index} value={video.id}>
                          {video.title.length > 50 ? video.title.slice(0, 50) + '…' : video.title}
                        </option>
                      ))}
                    </select>
                    <div className="PCT-TrialSelect">
                              <button onClick={() => handleTrialSelect(2)}>2 Trials</button>
                              <button onClick={() => handleTrialSelect(3)}>3 Trials</button>
                              <button onClick={() => handleTrialSelect(4)}>4 Trials</button>
                              <button onClick={() => handleTrialSelect(5)}>5 Trials</button>
                              <button onClick={() => handleTrialSelect(10)}>10 Trials</button>
                    </div>
                            <div className="PCT-TrialRepeatCycles">Repeat Trial Cycles: {numTrials}</div>
                    {selectedVideoId && (
                      <InputForm 
                        formData={sharedFormData}
                        onUpdate={(updatedRows) => {
                                    handleFormUpdate(updatedRows);
                                    setSharedFormData([]);
                                  }} 
                        playerRef={playerRef}
                        videoId={selectedVideoId}
                        handlePlay={handlePlay}
                        handlePause={handlePause}
                        handleStop={handleStop}
                        handleRepeat500ms={handleRepeat500ms}
                        handleRepeatCycle={handleRepeatCycle}
                        handleRepeat2s={handleRepeat2s}
                        onShare={handleShareTask}
                        setProgress={setProgress}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
            {showModal && (
                <div className="PCT-modal-overlay">
                  <div className="PCT-modal-content">
                    <div className="PCT-modal-header">
                      <button className="PCT-modal-close" onClick={() => closeModal()}>✖</button>
                    </div>
                    <div className="PCT-modal-body">
                      <PlaylistSelector onPlaylistSelect={(id) => {
                        setPLAYLIST_ID(id);
                        closeModal();
                      }} />
                    </div>
                  </div>
                </div>
            )}
          </div>
      </div>
    <footer className="PCT-bottom-footer" role="contentinfo" aria-label="site footer">
      © The iSpeakWell Project 2025-2026 — All rights reserved.
    </footer>
  </div>
  );
}
export default PodCastTools;